<mat-drawer-container>
  <mat-drawer [mode]="drawerMode" [opened]="false" [position]="'end'" [disableClose]="true" #matDrawer>
    <router-outlet></router-outlet>
  </mat-drawer>
  <mat-drawer-content>
    <div class="content">
      <!-- Header -->
      <div class="header">
        <!-- Title -->
        <div class="title">
          <folders-breadcrumbs [path]="folder.path" [stopAt]="sharedResource.related_to_id"></folders-breadcrumbs>
          <h1>{{ folder.name }}</h1>
        </div>

        <!-- Main actions -->
        <div class="main-actions">
          <!-- Add task button -->
        </div>
        <div class="loader" *ngIf="loading">
          <mat-progress-bar [mode]="'indeterminate'"></mat-progress-bar>
        </div>
      </div>

      <div class="tasks-list">
        <ng-container *ngIf="childFolders && childFolders.length > 0">
          <div
            [id]="'task-' + childFolder.id"
            class="task"
            *ngFor="let childFolder of childFolders; trackBy: trackByFn"
            [ngClass]="'type-section'"
            draggable="true"
            (dragstart)="handleDragStart($event, childFolder)"
            (dragover)="handleDragOver($event, childFolder)"
            (drop)="handleDrop($event, childFolder)"
            (dragend)="handleDragEnd($event)"
          >
            <!-- Task content -->
            <div class="task-content">
              <!-- Drag handle -->
              <div class="drag-handle" cdkDragHandle>
                <mat-icon [svgIcon]="'drag_indicator'"></mat-icon>
              </div>

              <!-- Task link -->
              <a class="pointer">
                <div class="title">
                  <a [routerLink]="['../' + childFolder.id]"
                    ><span *ngIf="childFolder.name">{{ childFolder.name }}</span></a
                  >
                </div>

                <div class="due-date mr-2">
                  {{ childFolder.file_size | filesize }}
                </div>
                <div class="due-date">
                  {{ childFolder.num_files }} <ng-container *ngIf="childFolder.num_files == 1">file</ng-container
                  ><ng-container *ngIf="childFolder.num_files != 1">files</ng-container>
                </div>
                <div class="due-date"></div>
              </a>
            </div>
          </div>
        </ng-container>
        <ng-container *ngIf="files && files.length > 0">
          <!-- Files -->
          <div
            [id]="'task-' + file.id"
            class="task"
            *ngFor="let file of files; trackBy: trackByFn"
            [ngClass]="'type-task'"
            draggable="true"
            (dragstart)="handleDragStart($event, file)"
            (dragover)="handleDragOver($event, file)"
            (drop)="handleDrop($event, file)"
            (dragend)="handleDragEnd($event)"
          >
            <!-- Task content -->
            <div class="task-content">
              <!-- Drag handle -->
              <div class="drag-handle" cdkDragHandle>
                <mat-icon [svgIcon]="'drag_indicator'"></mat-icon>
              </div>

              <!-- Task link -->
              <a class="pointer">
                <div class="title">
                  <a (click)="viewFile(file)" class="pointer"
                    ><span *ngIf="file.name">{{ file.name }}</span></a
                  >
                </div>
                <div class="due-date mr-10" *ngIf="file.related_to_type && file.related_to_type != 'Project'">
                  {{ file.related_to_type }}: {{ file.related_to_name }}
                </div>
                <div class="due-date mr-10">
                  {{ file.file_size | filesize }}
                </div>
                <div class="due-date mr-10">
                  {{ file.user?.full_name }}
                </div>
                <div class="due-date mr-10">
                  {{ file.created_at | date: 'LLL dd, y' }}
                </div>
                <div class="due-date">
                  <button class="more-menu" mat-icon-button [matMenuTriggerFor]="moreMenu">
                    <mat-icon [svgIcon]="'more_vert'"></mat-icon>
                  </button>

                  <mat-menu #moreMenu="matMenu">
                    <button mat-menu-item (click)="downloadFile(file)">
                      <mat-icon [svgIcon]="'get_app'"></mat-icon>
                      <span>Download</span>
                    </button>
                  </mat-menu>
                </div>
              </a>
            </div>
          </div>
        </ng-container>
      </div>
    </div>
  </mat-drawer-content>
</mat-drawer-container>
<span #emptyItem></span>
